export const defaultTileLayerUrl =
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
export const defaultTileLayerAttribution = '© OpenStreetMap contributors'

export const defaultErrorMessage = 'tours_block.error_map_description'

export const defaultZoom = 15

export const defaultIconSize: [number, number] = [40, 47]
export const defaultIconAnchor: [number, number] = [20, 47]
export const defaultPopupAnchor: [number, number] = [0, -47]
